export function logoFromNameFilter(): (value: string)  => string {
    return (value) => value.substr(0, 2).toUpperCase();
}
